/* global $ */

"use strict"

import "./_polyfills.js"

import loadGoogleMapsAPI from "load-google-maps-api"
import mapMarker from "mapMarker"

import Select from "./_select"
import loadjs from "loadjs"
import _ from "./_helper"
import clamp from "./_clamp"
import Cookies from "cookies-js"
import HoverIntent from "hoverintent"

function main() {
  const highlight = document.querySelector(".js-nav-highlight")
  const initialWidth = highlight.offsetWidth
  const navigationToggle = document.querySelector(".js-nav-toggle")

  let mobileSubNavItems = Array.from(
    document.querySelectorAll(".sub-nav.js-sub-nav")
  )

  for (var i = 0; i < mobileSubNavItems.length; i++) {
    mobileSubNavItems[i].addEventListener("click", () => {
      if (navigationToggle) {
        navigationToggle.click()
      }
    })
  }

  const closeForTodayBtns = Array.from(
    document.querySelectorAll(".js-closed-for-today")
  )

  for (var i = 0; i < closeForTodayBtns.length; i++) {
    closeForTodayBtns[i].addEventListener("click", e => {
      $.ajax({
        type: "POST",
        url: "/toggle-closed-today",
        data: {
          tenant_id: e.target.getAttribute("data-tenant_id"),
          day: e.target.getAttribute("data-day")
        },
        success: data => {
          if (data.success == true) {
            let closedTodayLabel = document.querySelector(
              ".day-" +
                e.target.getAttribute("data-day") +
                ".closed-today-label"
            )
            let hoursToday = document.querySelector(
              ".day-" + e.target.getAttribute("data-day") + ".day-hours-input"
            )
            let twentyFourHoursLabel = document.querySelector(
              ".day-" + e.target.getAttribute("data-day") + ".day-24-label"
            )

            if (data.closed == 1) {
              e.target.innerHTML = "Open Today"
              closedTodayLabel.style.display = "block"
              hoursToday.style.display = "none"
              twentyFourHoursLabel.style.display = "none"
            } else {
              e.target.innerHTML = "Close Today"
              closedTodayLabel.style.display = "none"
              twentyFourHoursLabel.style.display = "none"
              hoursToday.style.display = "block"
            }
          }
        }
      })
    })
  }

  let open24HoursBtns = document.getElementsByClassName("open-24-hours-btn")

  for (let i = 0; i < open24HoursBtns.length; i++) {
    if (typeof open24HoursBtns[i] !== "undefined") {
      open24HoursBtns[i].addEventListener("click", e => {
        let dayId = e.target.getAttribute("data-day")

        $.ajax({
          type: "POST",
          url: "/toggle-tenant-24-hours",
          data: {
            tenant_id: e.target.getAttribute("data-tenant-id"),
            day_id: dayId
          },
          success: data => {
            let label = document.getElementsByClassName(
              "day-" + dayId + " day-24-label"
            )[0]
            let inputs = document.getElementsByClassName(
              "day-" + dayId + " day-hours-input"
            )[0]
            let closedTodayLabel = document.querySelector(
              ".day-" +
                e.target.getAttribute("data-day") +
                ".closed-today-label"
            )

            if (data.twentyFour) {
              label.style.display = "block"
              inputs.style.display = "none"
              closedTodayLabel.style.display = "none"
              e.target.innerHTML = "Not Open 24 Hours"
            } else {
              label.style.display = "none"
              inputs.style.display = "block"
              e.target.innerHTML = "Open 24 Hours"
            }
          }
        })
      })
    }
  }

  let allOpen24hoursBtn = document.getElementsByClassName(
    "all-open-24-hours-btn"
  )[0]

  if (allOpen24hoursBtn) {
    allOpen24hoursBtn.addEventListener("click", e => {
      $.ajax({
        type: "POST",
        url: "/toggle-tenants-all-24-hours",
        data: {
          tenant_id: e.target.getAttribute("data-tenant-id")
        },
        success: () => {
          let dayLabels = document.getElementsByClassName("day-24-label")

          for (var i = 0; i < dayLabels.length; i++) {
            dayLabels[i].innerHTML = "Open 24 Hours"
          }
        }
      })
    })
  }

  document.querySelector(".js-nav").addEventListener("mouseover", e => {
    const link = e.target.closest(".js-nav-link")
    if (!link) return

    const left = initialWidth + 2 + link.offsetLeft - 10
    const width = link.offsetWidth + 20

    highlight.style.transform = `translate3d(${left}px, 0, 0) scale(${width /
      initialWidth}, 1)`
  })

  document.querySelector(".js-nav").addEventListener("mouseleave", e => {
    highlight.style.transform = "none"
  })

  /**
   * Icons
   */
  import("icons").then(svg => {
    const div = document.createElement("div")
    div.style.display = "none"
    div.innerHTML = svg
    document.body.insertBefore(div, document.body.firstElementChild)
  })

  /**
   * Clamp
   */
  clamp()

  /**
   * Nav
   */
  const nav = document.querySelector(".js-nav")
  const navToggle = document.querySelector(".js-nav-toggle")

  if (Cookies.get("menu-open") === "true" && _.windowWidth() >= 1200) {
    document.body.classList.add("nav-open")
  }

  if (navToggle) {
    navToggle.addEventListener("click", e => {
      e.preventDefault()

      document.body.classList.toggle("nav-open")

      if (_.windowWidth() >= 1200) {
        Cookies.set(
          "menu-open",
          document.body.classList.contains("nav-open").toString()
        )
      }
    })
  }

  nav.addEventListener("click", e => {
    const expand = e.target.closest(".js-nav-expand")

    if (expand) {
      const item = expand.closest(".js-nav-item")
      item.classList.toggle("is-active")
    }
  })

  /**
   * Slider
   */
  const sliderEls = Array.from(document.querySelectorAll(".js-slider"))
  sliderEls.forEach(sliderEl => {
    const info = sliderEl.querySelectorAll(".js-slider-info")
    const infoContainer = sliderEl.querySelector(".js-slider-info-container")
    // const content = document.querySelectorAll('.js-slider-content')
    const content = {}
    let selectedIndex = 0

    if (info.length && info[0].getAttribute("data-index") === "1") {
      infoContainer.classList.add("is-visible")
    }

    import("flickity").then(Flickity => {
      for (let j = 0; j < info.length; j++) {
        if (window.site.isAdmin) {
          // !isAdmin
          content[info[j].getAttribute("data-index")] =
            info[j].firstElementChild
          infoContainer.appendChild(info[j].firstElementChild)
        } else {
          const clone = info[j].firstElementChild.cloneNode(true)
          content[info[j].getAttribute("data-index")] = clone
          infoContainer.appendChild(clone)
        }
      }

      const slider = new Flickity(sliderEl, {
        cellSelector: ".js-slider-item",
        prevNextButtons: false,
        wrapAround: true,
        adaptiveHeight: true,
        autoPlay: 5000,
        draggable: !window.site.isAdmin
      })

      slider.on("select", () => {
        const newSelectedIndex = slider.selectedIndex
        if (newSelectedIndex === selectedIndex) return

        if (content[`${selectedIndex + 1}`]) {
          content[`${selectedIndex + 1}`].classList.remove("is-active")
        }
        if (content[`${newSelectedIndex + 1}`]) {
          infoContainer.classList.add("is-visible")
          content[`${newSelectedIndex + 1}`].classList.add("is-active")
        } else {
          if (infoContainer) {
            infoContainer.classList.remove("is-visible")
          }
        }
        selectedIndex = newSelectedIndex
      })

      const nextBtn = sliderEl.querySelector(".js-slider-next")
      const prevBtn = sliderEl.querySelector(".js-slider-prev")

      if (nextBtn) {
        nextBtn.addEventListener("click", () => {
          slider.next()
        })
      }

      if (prevBtn) {
        prevBtn.addEventListener("click", () => {
          slider.previous()
        })
      }
    })
  })

  /**
   * Grid
   */
  const grid = document.querySelector(".js-grid")
  if (grid) {
    import("packery").then(Packery => {
      // eslint-disable-next-line
      const packery = new Packery(grid, {
        itemSelector: ".js-grid-item",
        gutter: 0,
        percentPosition: true,
        transitionDuration: 0
      })

      if (window.site.isAdmin) {
        import("draggabilly").then(Draggabilly => {
          packery.getItemElements().forEach(function(itemElem) {
            var draggie = new Draggabilly(itemElem)
            packery.bindDraggabillyEvents(draggie)
          })

          // show item order after layout
          function orderItems() {
            var items = []

            packery.getItemElements().forEach(function(itemElem, i) {
              var item = {
                id: $(itemElem).data("id"),
                position: i
              }
              items.push(item)
            })

            var json = JSON.stringify(items)

            $.ajax({
              type: "POST",
              url: "/api/1.0/sections/update",
              data: {
                data: json
              },
              success: function(response) {},
              error: function() {
                alert("Something went wrong with saving the positions")
              }
            })
          }

          packery.on("dragItemPositioned", orderItems)
        })
      }
    })
  }

  /**
   * Share links
   */
  {
    const links = document.querySelectorAll(".js-share-link")

    for (let i = 0; i < links.length; i++) {
      links[i].addEventListener("click", e => {
        e.preventDefault()

        openWindow(links[i].href)
      })
    }
  }

  function openWindow(url, width = 600, height = 440) {
    const left = window.screen.width / 2 - width / 2
    const top = window.screen.height / 2 - height / 2

    window.open(
      url,
      "",
      `menubar=no,toolbar=no,resizable=yes,scrollbars=yes,width=${width},height=${height},top=${top},left=${left}`
    )
  }

  /**
   * Sidebar nav mobile dropdown
   */
  const sidebarNav = document.querySelector(".js-sidebar-nav")
  let sidebarItems

  if (sidebarNav) {
    sidebarItems = sidebarNav.querySelectorAll(".js-sidebar-nav-link")
  }

  if (sidebarNav && sidebarItems && sidebarItems.length) {
    const container = document.createElement("div")
    container.classList.add("mobile-select")
    const selectLabel = document.createElement("div")
    selectLabel.classList.add("mobile-select__label")
    container.appendChild(selectLabel)
    const select = document.createElement("select")

    const heading = document.querySelector(".js-sidebar-nav-heading")
    if (heading) {
      const headingOption = document.createElement("option")
      headingOption.setAttribute("selected", "selected")
      headingOption.setAttribute("disabled", "disabled")
      headingOption.textContent = selectLabel.textContent = heading.textContent.trim()
      select.appendChild(headingOption)
    }

    for (let i = 0; i < sidebarItems.length; i++) {
      const item = sidebarItems[i]
      const option = document.createElement("option")
      option.value = item.getAttribute("href")
      option.textContent = item.textContent.trim()
      select.appendChild(option)

      if (!heading && i === 0) {
        selectLabel.textContent = item.textContent.trim()
      }
    }

    container.appendChild(select)

    import("smoothscroll-polyfill").then(SmoothScroll => {
      select.addEventListener("change", e => {
        const target = document.querySelector(select.value)
        target.scrollIntoView({ behavior: "smooth" })
        window.history.replaceState({}, "", select.value)
        selectLabel.textContent =
          select.options[select.selectedIndex].textContent
      })
    })

    sidebarNav.parentNode.insertBefore(container, sidebarNav)
  }

  /**
   * Sticky sidebar
   */
  const sidebar = document.querySelector(".js-sidebar")
  if (sidebar) {
    initStickyfill()
    window.addEventListener("resize", initStickyfill)
  }

  let stickyfillEnabled = false

  function initStickyfill() {
    if (_.windowWidth() >= 1200 && !stickyfillEnabled) {
      stickyfillEnabled = true
      import("./_stickyfill").then(StickyFill => {
        StickyFill.add(sidebar)
      })
    } else if (_.windowWidth() < 1200 && stickyfillEnabled) {
      stickyfillEnabled = false
      import("./_stickyfill").then(StickyFill => {
        StickyFill.remove(sidebar)
      })
    }
  }

  /**
   * Sidebar nav scroll to
   */
  const links = document.querySelectorAll(".js-sidebar-nav-link")

  if (links.length) {
    import("smoothscroll-polyfill").then(SmoothScroll => {
      SmoothScroll.polyfill()

      for (let i = 0; i < links.length; i++) {
        const link = links[i]

        const href = link.getAttribute("href")
        const target = document.querySelector(href)

        if (target) {
          link.addEventListener("click", e => {
            e.preventDefault()
            target.scrollIntoView({ behavior: "smooth", block: "start" })
            window.history.replaceState({}, "", href)
          })
        }
      }
    })

    if (_.windowWidth() >= 1200) {
      import("gumshoejs").then(gumshoe => {
        gumshoe.init({
          selector: ".js-sidebar-nav-link",
          activeClass: "is-active",
          offset: _.windowHeight() / 3
        })
      })
    }
  }

  /**
   * Sidebar extras
   */
  {
    const extras = document.querySelectorAll(".js-sidebar-extras")

    if (extras.length) {
      for (let i = 0; i < extras.length; i++) {
        sidebar.appendChild(extras[i].cloneNode(true))
      }

      window.requestAnimationFrame(clamp)
    }
  }

  /**
   * Custom select
   */
  const selects = document.querySelectorAll(".js-select")
  if (selects.length) {
    for (let i = 0; i < selects.length; i++) {
      const select = selects[i]
      new Select(select) // eslint-disable-line
    }
  }

  /**
   * Map
   */
  const mapCanvas = document.querySelector(".js-map")
  if (mapCanvas) {
    loadGoogleMapsAPI({
      key: "AIzaSyBNBgyprgxCZp1Ham8u7j3Od19PcdMNltM"
    }).then(googleMaps => {
      const center = { lat: 53.481593, lng: -2.228194 }

      const map = new googleMaps.Map(mapCanvas, {
        zoom: 16,
        center,
        scrollwheel: false
      })

      // eslint-disable-next-line
      const marker = new googleMaps.Marker({
        position: center,
        map
      })
    })
  }

  /**
   * Typeform
   */
  const typeform = document.querySelector(".js-typeform")
  if (typeform) {
    loadjs("https://s3-eu-west-1.amazonaws.com/share.typeform.com/widget.js")
  }

  /**
   * Floorplan
   */
  const floorplan = document.querySelector(".js-floorplan")
  if (floorplan) {
    const pins = floorplan.querySelectorAll(".js-floorplan-pin")
    const p = []
    let hoverEnabled = true

    let initialSelection = null
    let initialCategory = "popular"

    let hash = window.location.hash
    if (hash && hash.length > 1) {
      hash = hash.substr(1)
      if (!isNaN(parseFloat(hash)) && isFinite(hash)) {
        // is numeric
        initialSelection = floorplan.querySelector(`[data-unit="${hash}"]`)
      } else {
        initialCategory = hash
      }
      hoverEnabled = false
    }

    if (!initialSelection) {
      const radio = document.querySelector(
        `.js-floorplan-category[value="${initialCategory}"]`
      )
      if (radio) radio.checked = true
    }

    for (let i = 0; i < pins.length; i++) {
      const cats = pins[i].getAttribute("data-category").split(",")
      let visible = false
      const image = pins[i].querySelector("img")
      let imageLoaded = false

      if (initialSelection) {
        if (initialSelection === pins[i]) {
          image.src = image.getAttribute("data-src")
          imageLoaded = true
          visible = true
          pins[i].classList.add("is-visible")
        }
      } else if (cats.indexOf(initialCategory) !== -1) {
        image.src = image.getAttribute("data-src")
        imageLoaded = true
        visible = true
        pins[i].classList.add("is-visible")
      }

      p.push({
        el: pins[i],
        cats,
        visible,
        image,
        imageLoaded
      })
    }

    function updateCategory(category) {
      hoverEnabled = false

      const transitionDelayed = floorplan.querySelector(".no-transition-delay")
      if (transitionDelayed)
        transitionDelayed.classList.remove("no-transition-delay")

      window.history.replaceState({}, "", `#${category}`)

      for (let i = 0; i < p.length; i++) {
        if (p[i].cats.indexOf(category) !== -1 && p[i].visible === false) {
          p[i].el.classList.add("is-visible")
          p[i].visible = true

          if (!p[i].imageLoaded) {
            p[i].image.src = p[i].image.getAttribute("data-src")
            p[i].imageLoaded = true
          }
        } else if (
          p[i].cats.indexOf(category) === -1 &&
          p[i].visible === true
        ) {
          p[i].visible = false
          p[i].el.classList.remove("is-visible")
        }
      }
    }

    const dropdown = document.querySelector(".js-floorplan-dropdown-select")
    const dropdownLabel = document.querySelector(".js-floorplan-dropdown-label")

    window.addEventListener(
      "change",
      e => {
        if (e.target.name !== "category") return

        updateCategory(e.target.value)

        const option = dropdown.querySelector(
          `option[value="${e.target.value}"]`
        )
        if (option) {
          option.selected = true
          dropdownLabel.textContent = option.textContent.trim()
        }
      },
      true
    )

    /**
     * Dropdown (small screens)
     */

    if (!initialSelection && initialCategory) {
      const option = dropdown.querySelector(
        `option[value="${initialCategory}"]`
      )
      if (option) {
        option.selected = true
        dropdownLabel.textContent = option.textContent.trim()
      }
    }

    dropdown.addEventListener("change", e => {
      const option = dropdown.options[dropdown.selectedIndex]
      updateCategory(option.value)
      dropdownLabel.textContent = option.textContent.trim()

      document.querySelector(
        `.js-floorplan-category[value="${option.value}"]`
      ).checked = true
    })

    /**
     * Hover
     */
    let hovered = null
    function handleHoverAndClick(e) {
      if (!hoverEnabled) return
      if (e.target && e.target.id) {
        const id = e.target.id.match(/:([0-9]+)/)
        if (!id) return
        const pin = floorplan.querySelector(`[data-unit="${id[1]}"]`)
        if (!pin) return

        if (hovered) {
          hovered.el.classList.remove("is-visible")
          hovered.el.classList.remove("no-transition-delay")
          hovered.visible = false
        }

        const pinref = p.filter(a => a.el === pin)
        hovered = pinref[0]
        hovered.visible = true
        hovered.el.classList.add("is-visible")
        hovered.el.classList.add("no-transition-delay")

        if (!hovered.imageLoaded) {
          hovered.image.src = hovered.image.getAttribute("data-src")
          hovered.imageLoaded = true
        }
      }
    }
    const units = Array.from(floorplan.querySelectorAll('[id^="unit:"]'))
    units.forEach(unit => {
      HoverIntent(unit, handleHoverAndClick, () => {})
    })

    // floorplan.addEventListener('mouseover', handleHoverAndClick)
    floorplan.addEventListener("click", handleHoverAndClick)
  }

  /**
   * News load more
   */
  let offsetNews = 1

  window.addEventListener("click", e => {
    const loadMoreBtn = e.target.closest(".js-load-more")
    if (!loadMoreBtn) return

    e.preventDefault()

    const container = document.querySelector(".js-load-more-container")
    const headers = {
      "X-Requested-With": "XMLHttpRequest"
    }
    const categoryContent = document.querySelector(".category-filter-value")
      .textContent
    const category = categoryContent !== "Category" ? categoryContent : "all"
    const yearContent = document.querySelector(".year-filter-value").textContent
    const year = yearContent !== "Year" ? yearContent : null
    const monthContent = document.querySelector(".month-filter-value")
      .textContent
    const month = monthContent !== "Month" ? monthContent : null
    const formData = new window.FormData()

    formData.append(
      "_token",
      document.querySelector('meta[name="csrf-token"]').content
    )
    formData.append("category", category)
    formData.append("year", year)
    formData.append("month", month)
    formData.append("offset", offsetNews)

    loadMoreBtn.setAttribute("disabled", "disabled")
    loadMoreBtn.textContent = "Loading Articles..."

    window
      .fetch(`${window.site.url}/news/load-more`, {
        method: "post",
        body: formData,
        credentials: "include",
        headers
      })
      .then(res => res.json())
      .then(res => {
        offsetNews += 1

        loadMoreBtn.setAttribute(
          "href",
          window.site.url + "/news/load-more/" + offsetNews
        )
        loadMoreBtn.removeAttribute("disabled")
        loadMoreBtn.textContent = "More Articles"

        container.setAttribute("data-max", res.max)
        container.innerHTML += res.news

        if (offsetNews * 9 >= res.max) {
          loadMoreBtn.parentNode.removeChild(loadMoreBtn)
        }
      })
  })

  const categoryNews = document.querySelector(".category-filter")

  if (categoryNews) {
    const year = document.querySelector(".year-filter")
    const month = document.querySelector(".month-filter")
    const categoryNews = document.querySelector(".category-filter")
    const categoryNewsValue = document.querySelector(".category-filter-value")
      .textContent
    const yearValue = document.querySelector(".year-filter-value").textContent
    const monthValue = document.querySelector(".month-filter-value").textContent

    Array.from(categoryNews.querySelectorAll("li button")).forEach(category => {
      category.addEventListener("click", e => {
        let href = ""

        if (category.getAttribute("data-value") === "") {
          category.setAttribute("data-value", "all")
        }

        if (
          Number.isInteger(parseInt(yearValue)) &&
          Number.isInteger(parseInt(monthValue))
        ) {
          href = `/news/filter/${category.getAttribute(
            "data-value"
          )}/${yearValue}/${monthValue}`
        } else if (Number.isInteger(parseInt(yearValue))) {
          href = `/news/filter/${category.getAttribute(
            "data-value"
          )}/${yearValue}`
        } else {
          href = `/news/filter/${category.getAttribute("data-value")}`
        }

        window.location.href = href
      })
    })

    Array.from(year.querySelectorAll("li button")).forEach(year => {
      year.addEventListener("click", e => {
        let href = ""

        if (e.target.textContent === "Year") {
          if (categoryNewsValue !== "Category") {
            href = `/news/filter/${categoryNewsValue}`
          } else {
            href = `/news`
          }
        } else {
          if (
            categoryNewsValue !== "Category" &&
            Number.isInteger(parseInt(monthValue))
          ) {
            href = `/news/filter/${categoryNewsValue}/${year.getAttribute(
              "data-value"
            )}/${monthValue}`
          } else if (categoryNewsValue !== "Category") {
            href = `/news/filter/${categoryNewsValue}/${year.getAttribute(
              "data-value"
            )}/01`
          } else if (Number.isInteger(parseInt(monthValue))) {
            href = `/news/filter/date/${year.getAttribute(
              "data-value"
            )}/${monthValue}`
          } else {
            href = `/news/filter/date/${year.getAttribute("data-value")}`
          }
        }

        window.location.href = href
      })
    })

    Array.from(month.querySelectorAll("li button")).forEach(month => {
      month.addEventListener("click", e => {
        let href = ""

        if (e.target.textContent === "Month") {
          if (
            categoryNewsValue !== "Category" &&
            Number.isInteger(parseInt(yearValue))
          ) {
            href = `/news/filter/${categoryNewsValue}/${yearValue}`
          } else if (categoryNewsValue !== "Category") {
            href = `/news/filter/date/${new Date().getFullYear()}`
          } else if (Number.isInteger(parseInt(yearValue))) {
            href = `/news/filter/date/${yearValue}`
          } else {
            href = `/news/filter/date/${new Date().getFullYear()}`
          }
        } else {
          if (
            categoryNewsValue !== "Category" &&
            Number.isInteger(parseInt(yearValue))
          ) {
            href = `/news/filter/${categoryNewsValue}/${yearValue}/${month.getAttribute(
              "data-value"
            )}`
          } else if (categoryNewsValue !== "Category") {
            href = `/news/filter/date/${new Date().getFullYear()}/${month.getAttribute(
              "data-value"
            )}`
          } else if (Number.isInteger(parseInt(yearValue))) {
            href = `/news/filter/date/${yearValue}/${month.getAttribute(
              "data-value"
            )}`
          } else {
            href = `/news/filter/date/${new Date().getFullYear()}/${month.getAttribute(
              "data-value"
            )}`
          }
        }

        window.location.href = href
      })
    })
  }

  /**
   * Form
   */
  {
    const form = document.querySelector(".js-form")

    if (form) {
      const submitButton = form.querySelector('button[type="submit"]')
      const submitButtonLabel = submitButton.textContent

      form.addEventListener(
        "blur",
        e => {
          validate(form)
        },
        true
      )
      form.addEventListener(
        "input",
        e => {
          e.target.classList.add("has-input")
        },
        true
      )
      form.addEventListener("submit", e => {
        e.preventDefault()

        Array.from(form.querySelectorAll("input,textarea")).forEach(field => {
          field.classList.add("has-input")
        })
        if (validate(form, true)) {
          submitButton.textContent = "Sending..."
          submitButton.disabled = true
          const formData = new window.FormData(form)
          formData.append(
            "_token",
            document.querySelector('meta[name="csrf-token"]').content
          )
          window
            .fetch(`${window.site.url}/centre-information/contact`, {
              method: "post",
              body: formData,
              credentials: "include"
            })
            .then(res => res.json())
            .then(json => {
              submitButton.disabled = false
              submitButton.textContent = submitButtonLabel
              const successEl = document.createElement("div")
              successEl.classList.add("cf-success")
              successEl.innerHTML =
                "<p>Message has been sent successfully! We’ll aim to get back to you within 24 hours.</p>"
              form.parentNode.insertBefore(successEl, form)
              form.parentNode.removeChild(form)
            })
        }
      })
    }
  }

  /**
   * Table wrapper
   */
  {
    const tables = Array.from(document.querySelectorAll(".article table"))
    tables.forEach(table => {
      const wrapper = document.createElement("div")
      wrapper.classList.add("article-table-container")
      _.wrap(table, wrapper)
    })
  }
}

function validate(form, all = false) {
  let selector = "input.has-input, textarea.has-input"
  if (all) selector = "input, textarea"
  const fields = Array.from(form.querySelectorAll(selector))
  clearErrors(form)

  let errorCount = 0

  fields.forEach(field => {
    if (field.required && field.value.trim() === "") {
      if (field.classList.contains("js-select-field")) {
        const select = field.closest(".js-select")
        showError(select, `${select.getAttribute("aria-label")} is required`)
      } else {
        const label = form.querySelector(`label[for="${field.id}"]`)
        showError(field, `${label.textContent} is required`)
      }
      errorCount++
      return
    }
    if (field.type === "email" && !isEmail(field.value)) {
      showError(field, "Please enter a valid email address")
      errorCount++
    }
  })

  return errorCount === 0
}

function clearErrors(form) {
  const errors = Array.from(form.querySelectorAll(".form-error"))
  errors.forEach(error => {
    error.parentNode.removeChild(error)
  })

  const inputs = Array.from(form.querySelectorAll(".has-error"))
  inputs.forEach(input => {
    input.classList.remove("has-error")
  })
}

function showError(input, message) {
  const error = document.createElement("p")
  error.classList.add("form-error")
  error.textContent = message
  input.parentNode.insertBefore(error, input.nextSibling)
  input.classList.add("has-error")
}

function isEmail(email) {
  // eslint-disable-next-line
  const re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
  return re.test(email)
}

if (document.readyState !== "loading") {
  main()
} else {
  document.addEventListener("DOMContentLoaded", main)
}



// WEBPACK FOOTER //
// ./resources/assets/js/main.js